import React from 'react';
import { AdminPageHeader, AreaBar } from '../../components/admin/shell';
import PartyEnginePanel from '../../components/admin/partyEngine/PartyEnginePanel';

export default function EnginePage() {
  return (
    <>
      <AdminPageHeader section="party-engine" meta="Research → concepts → posters → review → publish." />
      <AreaBar note="Runs are started against one area at a time." />
      <PartyEnginePanel />
    </>
  );
}
